import { render, staticRenderFns } from "./NewShoppingCart.vue?vue&type=template&id=2261d49c&scoped=true&"
import script from "./NewShoppingCart.vue?vue&type=script&lang=js&"
export * from "./NewShoppingCart.vue?vue&type=script&lang=js&"
import style0 from "./NewShoppingCart.vue?vue&type=style&index=0&id=2261d49c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2261d49c",
  null
  
)

export default component.exports